import { StyleProvider } from "@ant-design/cssinjs";
import { App as AntApp, ConfigProvider } from "antd";
import type { ReactNode } from "react";
import { antdTheme } from "@/app/theme/antdTheme";

interface AntdProviderProps {
	children: ReactNode;
}

export function AntdProvider({ children }: AntdProviderProps) {
	return (
		<StyleProvider layer>
			<ConfigProvider theme={antdTheme}>
				<AntApp>{children}</AntApp>
			</ConfigProvider>
		</StyleProvider>
	);
}
